import {useMemo,useState, useEffect} from 'react';
import { useTheme } from '@mui/material';
import Select from 'react-select';

const SelectTipoDocSoftland = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    disabled,
    ...defaultProps
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [selectedValue, setSelectedValue] = useState(value);
    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };
    const options = [
        {
            value: '96',
            label: 'DNI'
        },
        {
            value: '80',
            label: 'CUIT'
        }
    ];

    useEffect(() => {
        if (typeof value === 'string') {
            setSelectedValue(options.find((opt) => opt.value === value));
        }
    }, [value]);
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        menu: (base) => ({
            ...base,
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? (isDarkMode ? '#90caf9' : '#fff') : (isDarkMode ? '#e0e0e0' : '#000'),
            background: state.isSelected ? (isDarkMode ? '#1a3a5c' : '#0364ff') : (isDarkMode ? '#2d3a52' : '#fff'),
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: isDarkMode ? '#e0e0e0' : '#fff',
            },
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: '#0364ff',
                borderRadius: 5
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        control: (styles)=>({
            ...styles,
            borderRadius: 7,
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        input: (styles) => ({
            ...styles,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        placeholder: (styles) => ({
            ...styles,
            color: isDarkMode ? '#b0bec5' : 'gray',
        })
    }), [isDarkMode])
    return (
        <Select
            {...defaultProps}
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isDisabled={disabled}
        />
    );
};

SelectTipoDocSoftland.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectTipoDocSoftland;